import { useState } from 'react';
import { marqueeItems, navSections } from '@/mocks/gossip';

export default function TopBar() {
  const [open, setOpen] = useState(false);
  const anchors = ['#speed', '#speed', '#evidence', '#comments', '#circles'];

  return (
    <header className="sticky top-0 z-40 border-b border-background-200/80 bg-background-50/90 backdrop-blur">
      {/* 公告速递条 */}
      <div className="border-b border-background-200/70 bg-primary-600">
        <div className="mx-auto flex max-w-[1240px] items-center gap-3 overflow-hidden px-4 md:px-6">
          <span className="flex shrink-0 items-center gap-1.5 py-2 text-xs font-bold text-background-50">
            <i className="ri-radar-line text-sm" />
            速递中
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="animate-readdy-marquee flex w-max items-center gap-10 whitespace-nowrap py-2">
              {[...marqueeItems, ...marqueeItems].map((item, i) => (
                <span key={i} className="text-xs font-medium text-primary-50">
                  {item}
                </span>
              ))}
            </div>
          </div>
          <span className="hidden shrink-0 items-center gap-1.5 text-xs font-medium text-primary-100 sm:flex">
            <i className="ri-time-line" /> 实时
          </span>
        </div>
      </div>

      {/* 主导航 */}
      <div className="mx-auto flex max-w-[1240px] items-center justify-between gap-4 px-4 py-3.5 md:px-6">
        <a href="#top" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-lg text-background-50">
            <i className="ri-chat-smile-fill" />
          </span>
          <span className="font-heading text-xl font-black tracking-tight text-foreground-950">
            91<span className="text-primary-600">吃瓜</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {navSections.map((n, i) => (
            <a
              key={n.label}
              href={anchors[i]}
              className="flex items-center gap-1.5 whitespace-nowrap rounded-full px-3.5 py-2 text-sm font-medium text-foreground-700 transition hover:bg-background-100 hover:text-foreground-950"
            >
              <i className={`${n.icon} text-base text-primary-500`} />
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-2 md:flex">
          <button
            type="button"
            aria-label="搜索"
            className="flex h-10 w-10 items-center justify-center rounded-full border border-background-200 bg-background-50 text-foreground-700 transition hover:border-primary-300 hover:text-primary-600"
          >
            <i className="ri-search-line text-lg" />
          </button>
          <a
            href="#commentBox"
            className="flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2.5 text-sm font-bold text-background-50 transition hover:bg-primary-600"
          >
            <i className="ri-chat-new-line text-base" />
            前排发言
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="菜单"
          className="flex h-10 w-10 items-center justify-center rounded-full border border-background-200 text-foreground-800 md:hidden"
        >
          <i className={open ? 'ri-close-line text-xl' : 'ri-menu-3-line text-xl'} />
        </button>
      </div>

      {/* 移动菜单 */}
      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          {navSections.map((n, i) => (
            <a
              key={n.label}
              href={anchors[i]}
              onClick={() => setOpen(false)}
              className="flex items-center gap-2.5 rounded-xl px-3 py-3 text-sm font-medium text-foreground-800 hover:bg-background-100"
            >
              <i className={`${n.icon} text-base text-primary-500`} />
              {n.label}
            </a>
          ))}
          <a
            href="#commentBox"
            onClick={() => setOpen(false)}
            className="mt-2 flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-4 py-3 text-sm font-bold text-background-50"
          >
            <i className="ri-chat-new-line" /> 前排发言
          </a>
        </div>
      )}
    </header>
  );
}